import { useEffect, useId } from 'react';
import { ToastInsetAxis, clearToastObstruction, registerToastObstruction } from '@/utils/toastInsets';

/**
 * Declares that this component occupies the toast corner, so toasts move clear of it while it is on
 * screen. Use `right` for a full-height overlay toasts must pass beside, `bottom` for a short one
 * they can stack on top of. Pass null whenever the overlay is hidden — the registration is released
 * on unmount either way.
 *
 * The registration key is per-instance, so the many closed copies of a per-answer drawer cannot
 * release the one copy that is actually open.
 */
export const useToastObstruction = (axis: ToastInsetAxis, sizePx: number | null): void => {
	const id = useId();

	useEffect(() => {
		if (sizePx === null) {
			clearToastObstruction(axis, id);
			return;
		}

		registerToastObstruction(axis, id, sizePx);
		return () => clearToastObstruction(axis, id);
	}, [axis, id, sizePx]);
};
